"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedAccountRoutes = void 0;
const route_1 = require("../route");
class LinkedAccountRoutes extends route_1.Route {
    constructor() {
        super('linked_accounts');
    }
    getLinkedAccounts() {
        return this.get('/');
    }
    getLinkedAccount(linkedAccountId) {
        return this.get(`/${linkedAccountId}`);
    }
    createLinkedAccount(currency, type, phone, carrier, country) {
        return this.post('/', { currency, type, phone, carrier, country });
    }
    linkBankAccount(accountNumber, accountName, bankId, currency, sortCode) {
        return this.post('/bank', { accountNumber, accountName, bankId, currency, sortCode });
    }
    resolveBank(accountNumber, bankId) {
        return this.post('/bank/resolve', { accountNumber, bankId });
    }
    getBanks(country) {
        return this.get('/banks', { country });
    }
    unlink(linkedAccountId) {
        return this.post('/unlink', { linkedAccountId });
    }
    verify(linkedAccountId, otpCode, otpType) {
        return this.post('/verify', { linkedAccountId, otpCode, otpType });
    }
    resolveEuropeanBank(accountNumber, sortCode, type) {
        return this.post('/bank/europe/validate', { accountNumber, sortCode, type });
    }
    verifyMicroTransaction(linkedAccountId, debitAmount) {
        return this.post('/microtransactions/verify', { linkedAccountId, debitAmount });
    }
    getInitialCardChargeAmount(currency) {
        return this.get('/card/initial_charge_amount', { currency });
    }
}
exports.LinkedAccountRoutes = LinkedAccountRoutes;
//# sourceMappingURL=linked_accounts.js.map